import React from 'react'
import Gram from './../../assets/img/gram.jpg';
import Wheat from './../../assets/img/wheat.jpg';
import Lentil from './../../assets/img/lentil.jpg';
import Barley from './../../assets/img/barley.jpg';
import Toria from './../../assets/img/toria.jpg';
import Mustard from './../../assets/img/mustard.jpg';
import { Link } from 'react-router-dom';
const Rabi = () => {
  return (
    <div className="container my-3">

    <div className="abouts">
        <h5>Rabi Crops</h5>
    </div>

    <div className="about-box p-4 rounded shadow-lg" style={{textAlign:'justify'}}>

        <div className="row mb-1 justify-content-between">
            

            <div className="col-lg-12 mb-1">
                <h4>Wheat</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Wheat} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4">
                
                <p>C-306(Desi), WH-147, WH-283, WH-1021, WH-542, WH-711, PBW-502, PBW-509, PBW-343, PBW-373, Raj-3765, UP-2328, WH-1025, WH-912, DBW-17</p>
                <Link to={'/products/field-crops/rabi-crops/wheat'}>View more</Link>
                </div>

            </div>
            </div>

            <div className="col-lg-12 mb-1">
                <h4>Gram</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Gram} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>C-235, Haryana Chana No. 1, Haryana Chana No. 3, HC-5</p>
                <Link to={'/products/field-crops/rabi-crops/gram'}>View more</Link>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Lentil</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Lentil} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>Sapna, Garima LH 82-6</p>
                <Link to={'/products/field-crops/rabi-crops/lentil'}>View more</Link>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Barley</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Barley} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>BH-75, PL-426, BH-393</p>
                <Link to={'/products/field-crops/rabi-crops/barley'}>View more</Link>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Toria</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Toria} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>TL-15, TH-68, T-9</p>
                <Link to={'/products/field-crops/rabi-crops/toria'}>View more</Link>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Mustard</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Mustard} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>RH-30, T-59(VARUNA), Laxmi, RGN-48</p>
                <Link to={'/products/field-crops/rabi-crops/mustard'}>View more</Link>
                </div>

            </div>
            </div>

            
        </div>

        </div>
    </div>
  )
}

export default Rabi
